module.exports = __webpack_public_path__ + "static/media/coming-soon-bg.bec555e8.jpg";